import type { NotifyPort } from '@/features/messages/domain/notify'
import type { OrgTeam, OrgTeamPort } from '../domain/member'

type CreateTeamInput = Omit<OrgTeam, 'id'>

const createTeam = async (
	port: OrgTeamPort,
	input: CreateTeamInput,
	notify: NotifyPort,
): Promise<OrgTeam | null> => {
	try {
		const team = await port.createTeam(input)
		notify.success('hr.teamCreated')
		return team
	} catch {
		notify.error('hr.teamCreateFailed')
		return null
	}
}

export { createTeam }
export type { CreateTeamInput }
